/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useMemo } from 'react';
// utils
import { url } from 'utils/urls';
// material
import { Radio } from '@insticator/insticator-ui/dist/material';
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
import PreviewConfig from 'material/previewconfig/previewconfig'

// styles
import injectSheet from 'react-jss'
import styles from './articleredirect_styles'


/* ========== ~~~~~~~~~~ TRENDING NOW CONFIG V2: ADVANCED SECTION : ARTICLE REDIRECT ~~~~~~~~~~ ========== */
const ArticleRedirect = injectSheet(styles)((props) => {

  const { articleRedirect, onChange } = props
  
  const imgSrc = useMemo(() => {
    return `${url.image}/2.0/trendingnow/advanced/${articleRedirect === 'TOP' ? 'article-redirect-preview-top.png' : 'article-redirect-preview-commenting-unit.png'}`
  }, [articleRedirect])

  return (
    <SectionGroupV2 
      indented={true} 
      klass={`articleredirect ${props.classes.articleredirect}`} 
      title={'Article redirect'} 
      description={'Define where the user is redirected when selecting an article.'}
      rowGap={32} 
      direction={'column'}>
        <Space gap={48}>
          <Space direction={'column'}>
            <Radio 
              isList
              title={`To the top of the article`}
              checked={articleRedirect === 'TOP'}
              handleChange={() => onChange({ articleRedirect: 'TOP' })}
            />
            <Radio 
              isList
              title={`To the commenting unit (if active)`}
              checked={articleRedirect === 'COMMENTING_UNIT'}
              handleChange={() => onChange({articleRedirect: 'COMMENTING_UNIT'})}
            />
          </Space>
          <PreviewConfig>
          <img 
            src={imgSrc} 
            alt=""
            height={280}
            />
          </PreviewConfig>
        </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ArticleRedirect;